import type { BoxProps } from '@hover/blueprint';
import { Body, Box, Button, Image } from '@hover/blueprint';
import React from 'react';

import { useShareToast } from 'src/modules/homeownerApp/hooks';
import { copyLinkViaBrowserAPI } from 'src/shared/helpers/clipboard';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { useBrand } from 'src/shared/providers/Brand';

export interface HeaderProps extends BoxProps {
  orgBrandLogoUrl?: string;
}

export const Header = ({ orgBrandLogoUrl }: HeaderProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const toast = useShareToast();
  const { defaultLogo } = useBrand();
  const alt = orgBrandLogoUrl ? t('navbar.logo') : 'navbar.logoAlt';
  const src = orgBrandLogoUrl || defaultLogo;

  const copyUrl = async () => {
    const shareUrl = window.location.href;
    try {
      await copyLinkViaBrowserAPI(shareUrl);
      toast({
        description: t('share.messages.copyLink.success'),
        status: 'success',
      });
    } catch (e) {
      toast({
        description: t('share.messages.copyLink.fail'),
        status: 'error',
      });
    }
  };

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      marginX={{ base: 500, tablet: 700, width500: 300 }}
      marginY={{ base: 800, tablet: 500 }}
    >
      <Box flexDirection="column">
        <Image alignSelf="center" alt={alt} height={400} src={src} />
        {orgBrandLogoUrl && (
          <Body alignSelf="center" color="neutralTextLight">
            {t('navbar.poweredByHover')}
          </Body>
        )}
      </Box>
      <Button
        label={t('share.share')}
        marginBottom={300}
        onClick={copyUrl}
        size="large"
        variant="secondary"
      >
        {t('share.share')}
      </Button>
    </Box>
  );
};
